import { Routes } from '@angular/router';
import { HomeComponent } from './shared/pages/home/home.component';
import { SimulationComponent } from './shared/pages/simulation/simulation.component';
import { SubscriptionComponent } from './shared/pages/subscription/subscription.component';
import { EdocComponent } from './shared/pages/edoc/edoc.component';
import { RecordsComponent } from './shared/pages/records/records.component';
import { LeadsComponent } from './shared/pages/leads/leads.component';
import { ContractActionComponent } from './shared/pages/contract-action/contract-action.component';
import { ResumeComponent } from './shared/pages/contract-action/resume/resume.component';
import { DocumentsComponent } from './shared/pages/contract-action/documents/documents.component';
import { ExemptionComponent } from './shared/pages/contract-action/exemption/exemption.component';
import { MessagingComponent } from './shared/pages/contract-action/messaging/messaging.component';
import { DeliveryComponent } from './shared/pages/contract-action/delivery/delivery.component';
import { HistoryComponent } from './shared/pages/contract-action/history/history.component';
import { ParametersComponent } from './shared/pages/parameters/parameters.component';
import { authGuard } from './shared/authentication/auth.guard';
import { PvmoErrorPageComponent } from './shared/pages/pvmo-error-page/pvmo-error-page.component';
import { CallbackComponent } from './shared/pages/callback/callback.component';
import { AdministrationComponent } from './shared/pages/administration/administration.component';

export const APP_ROUTES: Routes = [
  // Wildcard, to handle non-existing route. Can redirect to a 404 component
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'callback', component: CallbackComponent },
  { path: 'administration', component: AdministrationComponent, canActivate: [authGuard] },
  { path: 'home', component: HomeComponent, canActivate: [authGuard] },
  { path: 'error', component: PvmoErrorPageComponent },
  { path: 'simulation', component: SimulationComponent, canActivate: [authGuard] },
  { path: 'simulation/:externalId', component: SimulationComponent, canActivate: [authGuard] },
  { path: 'subscription/:externalId', component: SubscriptionComponent, canActivate: [authGuard] },
  { path: 'records', component: RecordsComponent, canActivate: [authGuard] },
  { path: 'leads', component: LeadsComponent, canActivate: [authGuard] },
  { path: 'parameters', component: ParametersComponent, canActivate: [authGuard] },
  {
    path: 'contract-action-hub/:id',
    component: ContractActionComponent,
    children: [
      { path: 'resume', component: ResumeComponent, canActivate: [authGuard] },
      { path: 'signature', component: EdocComponent, canActivate: [authGuard] },
      { path: 'documents', component: DocumentsComponent, canActivate: [authGuard] },
      { path: 'messaging', component: MessagingComponent, canActivate: [authGuard] },
      { path: 'exemptionvr', component: ExemptionComponent, canActivate: [authGuard] },
      { path: 'delivery', component: DeliveryComponent, canActivate: [authGuard] },
      { path: 'filehistory', component: HistoryComponent, canActivate: [authGuard] }
    ]
  }
];
